<template>
  <div class="contain page8-con" id="Mobile8">
    <div class="contain-box myMain">
      <div class="links">
        <ul>
          <li>相关链接</li>
          <li>
            <div>
              <img src="@/assets/image/home/link1.png" @click="jump(1)" href="https://www.worldathletics.org/" />
            </div>
          </li>
          <li>
            <div>
              <img src="@/assets/image/home/link2.png" @click="jump(2)" href="http://www.athletics.org.cn/" />
            </div>
          </li>
          <li>
            <div>
              <img src="@/assets/image/home/link3.png" @click="jump(3)" href="https://www.chinaath.com/" />
            </div>
          </li>
        </ul>
      </div>
      <div class="partner-con">
        <div class="cooperation">
          <i class="line"></i>
          <h3>合作机构及支持单位</h3>
          <i class="line"></i>
        </div>
        <div class="partner">
          <ul>
            <li
              v-for="(item, index) in partner"
              :key="index"
              @click="switchHandle(index)"
              @mouseover="switchHandle(index)"
              :class="activeIndex == index ? 'isActive' : ''"
            >
              <div class="top">
                <img :src="require(`@/assets/image/home/logo${index}.png`)" alt="" />
              </div>
              <div class="bottom">
                {{ item.name }}
              </div>
            </li>
          </ul>
        </div>

        <div
          class="relevantLink"
          v-for="(item, index) in partner[activeIndex].partners"
          :key="index"
        >
          <h3 class="m-page8-title">{{ item.category }}</h3>
          <div class="con">
            <ul>
              <li v-for="(it, i) in item.list" :key="i" @click="gotourl(it)" class="relevantLink-li">
                <div class="category-li-img-wrapper">
                  <img :src="it.img" alt="" class="category-li-img" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 联系方式 -->
        <div class="contact hidden-md-and-up">
          <img
            src="@/assets/image//home/mobile/phone.png"
            alt="电话"
            class="phoneImg"
          />
          <p class="pNumber">010-8716 1759</p>
          <p class="numTip">业务咨询及投诉电话</p>
          <div class="codeImg">
            <img src="@/assets/image/qrcode/wechat.jpg" alt="二维码" style="width:100%;height:100%" />
          </div>

          <p class="codeTip">扫描添加官方微信号</p>
          <div class="emailBox">
            <div>
              <img src="@/assets/image//home/mobile/emil.png" alt="" />
            </div>
            <i class="line"></i>
            <div class="email">
              <p>业务邮箱：renzheng@chinaath.com</p>
              <p>廉政邮箱：zt@chinaath.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import footerCmp from "@/components/common/footer.vue";
import { getPartnerList } from "@/api/home/index";
export default {
  data() {
    return {
      partner: [
        {
          id: 1,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "中田认证",
          partners: [],
        },
        {
          id: 2,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "场地验收",
          partners: [],
        },
        {
          id: 3,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "面层审定",
          partners: [],
        },
        {
          id: 4,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "芯片审定",
          partners: [],
        },
        {
          id: 5,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "器材审定",
          partners: [],
        },
        {
          id: 6,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "步道审定",
          partners: [],
        },
        {
          id: 7,
          logo: "http://zhongtian.ezhangxiu.cn/resource/common/img/logo-img-1.png",
          name: "培训&注册",
          partners: [],
        },
      ],

      activeIndex: 0,
    };
  },
  components: {
    footerCmp,
  },
  created() {},
  mounted() {
    this.getPartners();
  },

  methods: {
        jump(type) {
      let url;
      switch (type) {
        case 2:
          url = "http://www.athletics.org.cn/";
          break;
        case 1:
          url = "https://www.worldathletics.org/";
          break;

        case 3:
           url = "https://www.chinaath.com/";
           break;   
        default:
          break;
      }
      window.open(url);
    },

    gotourl(item){  
      if(item && item.link)
       window.open(item.link);
    },
    getPartners() {
      getPartnerList({ show: 1 }).then((res) => {
        var self = this;
        if (res.errCode == 0) {
          var list = res.data.list;
        
          list.forEach((p) => {
            var w = self.partner.filter((x) => x.name == p.bizName)[0];
            if (w) {
              var exist = false;
              if(w.partners.length > 0){
                for(var i = 0; i < w.partners.length;i++){
                  if(w.partners[i].category == p.category){
                    w.partners[i].list.push(p);
                    exist = true;
                    break;
                  }
                }
              }

              if(!exist){
                w.partners.push({
                  category: p.category,
                  list:[p]
                });
              }
            }
          });
         
        }
      });
    },
    switchHandle(index) {
      this.activeIndex = index;
      this.tsData = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.page8-con {
  background-color: #fff;
  padding-top: 80px;
  box-sizing: border-box;
  .el-divider__text {
    font-weight: bold;
    background: #f0f2f5;
    font-size: 28px;
  }
  .contain-box {
    .links {
      background: #f9f9f9;
      margin-bottom: 60px;
      ul {
        display: flex;
        align-items: center;
        li {
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f9f9f9;
          height: 100%;
          flex: 1;
          &:nth-child(1) {
            width: 298px;
            height: 120px;
            font-size: 32px;
            background: url("~@/assets/image/home/jh.png") 100% 100% no-repeat;
          }
          div {
            border-right: 1px solid #e6e6e6;
            width: 100%;
          }
        }
      }
    }
    // 设置li的背景颜色
    $list-bg: #cf524f, #869eca, #e58c8d, #7fc4d9, #b793b2, #ebc272, #bbd37f;
    .partner-con .partner ul {
      border-bottom: 1px solid #d43230;
      margin-bottom: 40px;
      justify-content: flex-start;
      li {
        cursor: pointer;
        @each $c in $list-bg {
          $i: index($list-bg, $c);
          &:nth-child(#{$i }) {
            background: nth($list-bg, $i);
            color: nth($list-bg, $i);
          }
        }
        padding: 4px;
        width: 154px;
        height: 174px;
        border-radius: 8px;
        margin-bottom: 1%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .top {
          width: 100%;
          height: 116px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #fff;
          border-radius: 8px;
          img {
            width: 93px;
            height: 60px;
          }
        }
        .bottom {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }
      }

      .isActive:after {
        content: "";
        display: block;
        width: 154px;
        height: 3px;
        background-color: #cf524f;
        position: absolute;
        bottom: -10px;
      }

      li:after {
        content: "";
        display: none;
        width: 154px;
        height: 3px;
        background-color: #cf524f;
        position: absolute;
        bottom: -10px;
      }

      li:hover:after {
        display: block;
      }
    }
    .partner-con {
      .cooperation {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 66px;
        .line {
          display: inline-block;
          flex: 1;
          height: 1px;
          background: #d8d8d8;
        }
        h3 {
          font-size: 28px;
          font-weight: 400;
          color: #222222;
          line-height: 28px;
          margin: 0 30px;
        }
      }
      .partner {
        ul {
          display: flex;
          justify-content: space-between;
          flex-wrap: nowrap;
          overflow: hidden;
          li {
            margin: 0 0 10px 0;
          }
        }
      }
    }
    .m-page8-title {
      height: 60px;
      background: #f9f9f9;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
      color: #333333;
      font-size: 20px;
      font-weight: 500;
    }
    .con {
      ul {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        li {
          margin: 0;
          margin-right: 2%;
          margin-bottom: 2%;
          width: 15%;
          height: 17%;
          border: none;
          padding: 9px;
          .category-li-img{
            object-fit: contain;
            vertical-align: bottom;
            width: 176px;
            height: 84px;
            display: block;
          }
        }
      }
    }
    .category-li-img-wrapper{
      position: relative;
      width: auto;
      height: auto;
      display: inline-block;
    }
    .category-li-img-wrapper::after{
      content: '';
      position: absolute;
      border: 1px solid #f1f1f1;
      border-radius: 8px;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    // .relevantLink-li::after{
    //   content: '';
    //   position: absolute;
    //   border: 1px solid #f1f1f1;
    //   border-radius: 8px;
    //   top: 9px;
    //   left: 11px;
    //   width: 176px;
    //   height: 84px;
    //   box-sizing: border-box;
    // }
  }
}
@media screen and (max-width: 960px) {
  #Mobile8 {
    padding-top: 0;
    .contain-box {
      padding: 0.24rem 0.16rem 0.16rem 0.16rem;
      width: auto;
      .links {
        background: #f9f9f9;
        margin-bottom: 0.2rem;
        ul {
          width: 100%;
          flex-wrap: nowrap;
          height: auto;
          li {
            padding: 0;
            flex: 1;
            &:nth-child(1) {
              width: 1.19rem;
              height: 0.48rem;
              font-size: 0.14rem;
              font-weight: 600;
              color: #ffffff;
              line-height: 0.22rem;
              display: flex;
              justify-content: center;
              align-items: center;
              border-top-left-radius: 0.08rem;
              border-bottom-left-radius: 0.08rem;
              background-size: cover;
            }
            &:nth-child(n + 2) {
              background: #f9f9f9;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 0.24rem;
                height: 0.24rem;
              }
            }
            &:nth-child(4) {
              div {
                border-right: 0;
              }
            }
          }
        }
      }
      .partner-con {
        .cooperation {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0.2rem 0 0.16rem 0;
          .line {
            width: 0.4rem;
            height: 0.01rem;
            background: #d8d8d8;
          }
          h3 {
            width: 1.44rem;
            font-size: 0.16rem;
            font-weight: 400;
            color: #222222;
            line-height: 0.28rem;
            height: 0.28rem;
            background-color: #fff;
            margin: 0 0.2rem;
          }
        }
        .isActive{
          font-family: element-icons!important;
          speak: none;
          font-style: normal;
          font-weight: 400;
          font-variant: normal;
          text-transform: none;
          line-height: 1;
          vertical-align: baseline;
          display: inline-block;
          -webkit-font-smoothing: antialiased;
        }
        .isActive:after {
          content: "\e79c";
          display: block;
          width: 0.12rem;
          height: 0.12rem;
          border-radius: .06rem;
          background-size: 100% 100%;
          background-color: #fff;
          position: absolute;
          top: 0.07rem;
          right: 0.07rem;
          z-index: 999;
        }
      }
      .partner {
        ul {
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-wrap: wrap;
          border: none;
          margin: 0;
          li {
            margin: 0;
            margin-bottom: 0.12rem;
            border-radius: 0.04rem;
            padding: 0.04rem 0.04rem 0 0.04rem;
            width: auto;
            height: auto;
            .top {
              height: 50%;
              padding: 0.14rem;
              width: auto;
              border-radius: 0.04rem;
              img {
                width: 0.46rem;
                height: 0.3rem;
              }
            }
            .bottom {
              font-size: 0.14rem;
              line-height: 22px;
              font-weight: 500;
              color: #ffffff;
              margin: 0.04rem 0;
            }
            &:nth-child(5) {
              margin-left: 4%;
            }
            &:nth-child(7) {
              margin-right: 4%;
            }
          }
        }
      }
      .m-page8-title {
        height: 0.4rem;
        background: #f9f9f9;
        border-radius: 0.08rem;
        font-size: 0.14rem;
        font-weight: 500;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.08rem 0 0.16rem 0;
      }
      .con {
        ul {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          li {
            width: 0.73rem;
            height: 0.38rem;
            border: 0.01rem #8f8f8f ;
            margin: 0 0.08rem 0.08rem 0;
            padding: 0.06rem 0;
            &:nth-child(4n) {
              margin-right: 0;
            }
            img {
              max-width: 0.73rem;
              max-height: 0.348rem;
            }
            .category-li-img-wrapper{
              // max-width: 0.73rem;
              // max-height: 0.38rem;
            }
            
            .category-li-img-wrapper::after{
              border-width: .005rem;
              border-radius: .03rem;
            }
          }
        }
      }
      .contact {
        margin-top: 0.22rem;
        .phoneImg {
          width: 0.4rem;
          height: 0.4rem;
        }
        .pNumber {
          font-size: 0.27rem;
          font-weight: bold;
          color: #cc3b3f;
          line-height: 0.36rem;
          margin: 0.13rem 0 0.06rem 0;
        }
        p {
          font-size: 0.14rem;
          font-weight: 400;
          line-height: 0.14rem;
        }
        .numTip {
          color: #666666;
          margin-bottom: 0.24rem;
        }
        .codeImg {
          width: 1rem;
          height: 1rem;
        
          margin: 0 auto;
          image {
            width: 100%;
            height: 100%;
          }
        }
        .codeTip {
          color: #8b8b8b;
          margin-top: 0.16rem;
        }
        .emailBox {
          width: 100%;
          background: #f6f6f6;
          border-radius: 0.04rem;
          display: flex;
          align-items: center;
          padding: 0.21rem 0;
          margin-top: 0.2rem;
          img {
            width: 0.23rem;
            height: 0.2rem;
            margin-left: 0.2rem;
          }
          .line {
            display: inline-block;
            width: 0.01rem;
            height: 0.2rem;
            background: #d8d8d8;
            border-radius: 0.02rem;
            margin: 0 0.2rem;
          }
          .email {
            color: #8b8b8b;
            text-align: left;
            p:nth-child(1) {
              margin-bottom: 0.12rem;
            }
          }
        }
      }
    }
  }
}
</style>